/* eslint-disable no-unused-vars */
import { ActionType } from 'typesafe-actions';

import { GENERIC_STATE_KEYS, IGenericState } from '../root';

export interface IPublicUserAuthorizationDto extends IAuthorizationDto {
  returnUrl?: string;
  customerName: string;
  photoSeries: { id: string };
}

export interface IAuthorizationDto {
  id: string;
  email: string;
  customerCode: string;
  mustChangePassword: boolean;
  permissions: number[];
  preferredLang: string;
  sessionExpiresAt: string;
  askAdditionalInformation: boolean;
  token?: string;
  refreshToken?: string;
}

export interface ISessionState extends IGenericState {
  preferredLang: string;
  customerCode: string;
  unsupportedBrowser: boolean;
  useNativeCamera: boolean;
  startRecordingUserSession: boolean;
  publicUserTrackingInfo: IPublicUserTrackingInfo | null;
  deviceInfo: IDeviceInfo | null;
}

export type IPublicUserTrackingInfo = {
  // Id of the currently logged in user
  id: string,
  email: string,
  customerCode: string,
  customerName: string,
  publicUserPhotoSeriesRecipient: string,
  returnUrl: string,
  photoSeries: { id: string, vehicle: { registrationNo: string, vin: string } }
  sessionExpiresAt: string,
};

export type IDeviceInfo = {
  rawModel: string;
  supported: boolean;
  isLoading: boolean;
  error: Error | null;
  isForbiddenModel: boolean;
  deviceNotRedmiNote: boolean;
};

export type TSessionActions = ActionType<typeof import('./session.actions')>;

const SESSION_NAME = 'session';

const SESSION_STATE_KEYS = {
  ...GENERIC_STATE_KEYS,
  preferredLang: 'preferredLang',
  customerCode: 'customerCode',
  publicUserSessionData: 'publicUserSessionData',
  unsupportedBrowser: 'unsupportedBrowser',
  useNativeCamera: 'useNativeCamera',
  startRecordingUserSession: 'startRecordingUserSession',
  publicUserTrackingInfo: 'publicUserTrackingInfo',
  deviceInfo: 'deviceInfo'
};

 enum PERMISSION_TYPES {
  ViewCustomDamageTypes = 33,
  CapturePhotoSeries = 71,
  ViewThumbnails = 72,
}

export {
  SESSION_NAME, SESSION_STATE_KEYS, PERMISSION_TYPES
};
